import { fetchRequestWithTypes } from './index.js';
import { PurchaseSource } from 'stash/types/models/Transaction';

// Returns a user's buy destinations.

export const GET_BUY_DESTINATIONS_REQUEST = 'GET_BUY_DESTINATIONS_REQUEST';
export const GET_BUY_DESTINATIONS_SUCCESS = 'GET_BUY_DESTINATIONS_SUCCESS';
export const GET_BUY_DESTINATIONS_ERRORED = 'GET_BUY_DESTINATIONS_ERRORED';

export type GetBuyDestinationsSuccessAction = {
	type: typeof GET_BUY_DESTINATIONS_SUCCESS;
	response: {
		destinations: PurchaseSource[];
	};
};

export type GetBuyDestinationsResponse = {
	destinations: PurchaseSource[];
};

export const getBuyDestinations = (sourcePathType: string, pathId: string) => {
	return fetchRequestWithTypes({
		types: [
			GET_BUY_DESTINATIONS_REQUEST,
			GET_BUY_DESTINATIONS_SUCCESS,
			GET_BUY_DESTINATIONS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/orders/v1/transactions/destinations?sourcePathType=${sourcePathType}&pathId=${pathId}`,
		},
	});
};

export const CLEAR_BUY_DESTINATIONS = 'CLEAR_BUY_DESTINATIONS';

export type ClearBuyDestinationsAction = {
	type: typeof CLEAR_BUY_DESTINATIONS;
};

export const clearBuyDestinations = (): ClearBuyDestinationsAction => ({
	type: CLEAR_BUY_DESTINATIONS,
});
